import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

const TOKEN_KEY = "psl_auth_token";

export const getToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY) || null;
  } catch {
    return null;
  }
};

export const setToken = (token) => {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* ignore */
  }
};

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach Authorization: Bearer header on every request when we have a token.
// This is a Safari/iPad ITP workaround — httpOnly cookies get blocked on
// cross-origin requests by Intelligent Tracking Prevention. The backend
// accepts both the cookie AND the Bearer header (see get_current_user in
// /app/backend/server.py).
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
